webpackJsonp([46],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 01/03/2017.
	 */
	//js
	var Shared = __webpack_require__(115);
	var LanguageManager = __webpack_require__(5);
	
	//styles
	__webpack_require__(322);
	
	$(function () {
	  LanguageManager.init(function () {}, Shared.defaultLocale);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 117
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ })

});


// WEBPACK FOOTER //
// js/404.048cf21f86a09355907d.js